//#region src/files/file-extension-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Docx = ".docx", e.Doc = ".doc", e.Ttf = ".ttf", e.AD_PRT = ".AD_PRT", e.AD_SMP = ".AD_SMP", e.AD_ASM = ".AD_ASM", e.AD_DRW = ".AD_DRW", e;
}({});
//#endregion
export { e as FileExtensionEnum };
